export default [
  {
    path: "/business-school",
    name:
      "光华商学院|反复学、持续学、一起学，追求实战、实操、实用、实效、实践，帮助企业实现少躺坑、少走弯路、少花冤枉钱，用科学经营助推企业高质量发展!",
    component: () => import("@/views/business-school/business-school.vue"),
    meta: {
      title: "光华商学院"
    }
  },
  {
    path: "/internal-training",
    name:
      "企业内训|企业个性化、高效化的内部培训需求，光华商学院凭借自身在企业培训领域多年的深耕经验与专业积淀，推出按需定制企业内部培训服务",
    component: () => import("@/views/business-school/internal-training.vue"),
    meta: {
      title: "企业内训/学习项目"
    }
  },
  {
    path: "/mba",
    name:
      "光华研修班|八大研修班、首席人力官(CHO)班、职业经理人EMBA班、PMP项目经理班、首席增长官(CGO)班、新媒体营销师班、企业精益生产认证班、新晋管理者班、财税合规师班",
    component: () => import("@/views/business-school/mba.vue"),
    meta: {
      title: "光华MBA"
    }
  }
];
